import CrudReducerFactory from '../../../redux/CrudReducerFactory';
import initialState from './initialState';

const factory = new CrudReducerFactory('accounts', 'accounts', initialState);

export const reducer = factory.reducer;
export const actions = factory.actions;

export default reducer;
